import { createSelector } from '@reduxjs/toolkit'
import pickBy from 'lodash/pickBy'
import type { KindEntity, KindMap } from 'types/domain'

interface GraphKindsRootState {
  graph?: {
    kinds?: {
      all?: KindMap
    }
  }
}

interface KindsSelectorProps {
  params?: {
    deleted?: boolean
    kindId?: string
  }
}


const selectKinds = (state: Record<string, unknown>): KindMap | undefined => {
  const graphState = state as GraphKindsRootState
  return graphState.graph?.kinds?.all
}

const selectIncludeDeleted = (_state: Record<string, unknown>, props?: KindsSelectorProps): boolean | undefined => {
  return props?.params?.deleted
}

const selectKindId = (_state: Record<string, unknown>, props?: KindsSelectorProps): string | undefined => {
  return props?.params?.kindId
}

export const all = createSelector(selectKinds, selectIncludeDeleted, (kinds, includeDeleted): KindMap => {
  if (!kinds) {
    return {}
  }
  return pickBy(kinds, (k: KindEntity) => includeDeleted || !k.deleted)
})

export const selectOne = createSelector(selectKindId, all, (id, kinds): KindEntity | null => {
  if (!id) {
    return null
  }
  return kinds[id] ?? null
})
